<template>
  <div>
    <slot v-bind="{ slicedLocations }"></slot>
    <div v-show="showButton" class="flex mt-6 py-2 bg-white sticky bottom-0">
      <button-link
        @click.prevent="onMore"
        href="javascript:void(0)"
        class="inline-flex items-center justify-center px-4 py-2 mx-auto border-gray-500"
      >
        <span class="text-sm font-bold uppercase"
          >View More ({{ remainingCount }})</span
        >
      </button-link>
    </div>
  </div>
</template>

<script>
import ButtonLink from "@/components/Button/ButtonLink.vue";

const start = 7;

export default {
  components: {
    ButtonLink,
  },
  props: {
    params: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      slicedLocations: [],
      start,
    };
  },
  watch: {
    params: {
      handler(value, oldValue) {
        if (!oldValue) return;
        if (value.length !== oldValue.length) {
          this.setInitial();
        }
      },
    },
  },
  methods: {
    onMore() {
      if (!this.params) return;

      const items = this.params.slice(this.start, (this.start += start));
      this.slicedLocations.splice(this.start, 0, ...items);
      this.$emit("on:scroll", "bottom");
    },
    setInitial() {
      if (!this.params) return;
      this.slicedLocations = this.params.slice(0, this.start);
    },
  },
  computed: {
    remainingCount() {
      if (!this.params) return;
      return this.params.length - this.slicedLocations.length;
    },
    showButton() {
      if (!this.params) return;
      return this.params.length !== this.slicedLocations.length;
    },
  },
  mounted() {
    this.setInitial();
  },
};
</script>
